<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-select label="Hình thức vận chuyển" v-model="feeVolume.ShippingMethod" :items="shipping_methods" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-select label="Loại hàng" v-model="feeVolume.ProductType" :items="product_types" item-text="name" item-value="value"></v-select>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeVolume.VolumeFrom" :decimal="1" label="Số khối (Min)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeVolume.VolumeTo" :decimal="1" label="Số khối (Max)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <h-currency-input v-model="feeVolume.Amount" :decimal="0" label="Tiền phí" class="input-group--focused"></h-currency-input>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
export default {
    data() {
        return {
            product_types: configs.PRODUCT_TYPE,
            shipping_methods: configs.SHIPPING_METHOD
        }
    },
    computed: {
        ...mapState({
            loading: state => state.feeVolume.loading,
            feeVolume: state => state.feeVolume.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("feeVolume/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("feeVolume/setDetail", { data: {
                        ID: 0,
                        VolumeFrom: 0,
                        VolumeTo: 0,
                        Amount: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("feeVolume/setDetail", {
                data: this.feeVolume,
                id: this.feeVolume.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "FeeVolumeList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.feeVolume.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
